import { makeStyles } from '@material-ui/core/styles'
import star from 'src/assets/Buy_Policy_Images/Star.svg'
import downIcon from 'src/assets/Buy_Policy_Images/DownIcon.svg'
import React, { useState } from 'react'

const CoverageListItem = ({ coverageData }) => {
  const classes = useStyles()
  const [showDescription, setShowDescription] = useState(false)

  return (
    <div
      className={`${classes.coverageContainer} ${
        showDescription ? classes.fullBorder : null
      }`}
    >
      <div
        className={classes.coverageMainAction}
        onClick={() => setShowDescription(!showDescription)}
        id='coverageMainAction'
      >
        <span>
          <img src={star} alt='star' height={15} width={15} />
        </span>
        <div className={classes.coverageMainContent}>
          <span className={classes.coverageContent} id='coverageContent'>
            {coverageData?.trovityCoverageName}
          </span>
          {coverageData?.limit ? (
            <span className={classes.coverageLimit}>{coverageData?.limit}</span>
          ) : null}
        </div>
        <span>
          <img
            src={downIcon}
            alt='down-icon'
            className={`cursor-pointer ${
              showDescription ? classes.rotateIcon : null
            }`}
            id='rotateIcon'
          />
        </span>
      </div>
      {showDescription && coverageData?.trovityCoverageMeaning ? (
        <div className={classes.coverageDescriptionContainer}>
          {coverageData?.condition ? (
            <span className={classes.coverageCondition}>
              *&nbsp;{coverageData?.condition}
            </span>
          ) : null}
          <div
            className={classes.coverageMainDescriptionContent}
            id='coverageMainDescription'
          >
            <span className={classes.descriptionTitle}>
              You have to know this
            </span>
            <span className={classes.coverageDescription}>
              {coverageData?.trovityCoverageMeaning}
            </span>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default CoverageListItem

const useStyles = makeStyles({
  coverageContainer: {
    height: '100%',
    borderBottom: '1px solid  #D2D2D2',
    width: '95%',
  },
  fullBorder: {
    border: '1px solid  #D2D2D2',
  },
  coverageMainAction: {
    display: 'flex',
    width: '90%',
    gap: '10px',
    padding: '20px 5px',
    cursor: 'pointer',
  },
  coverageMainContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  coverageContent: {
    fontSize: '14px',
    fontWeight: '400',
    color: '#767676',
  },
  coverageMainDescriptionContent: {
    width: '90%',
    padding: '0px 10px 20px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  coverageDescription: {
    fontSize: '12px',
  },
  descriptionTitle: {
    color: '#1EA8CE',
    fontSize: '12px',
    fontWeight: 'bold',
  },
  rotateIcon: {
    transform: 'rotate(180deg)',
  },
  coverageDescriptionContainer: {
    display: 'flex',
    width: '100%',
    gap: '5px',
    flexDirection: 'column',
  },
  coverageLimit: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  coverageCondition: {
    fontSize: '12px',
    color: '#4A4A4A',
    paddingLeft: '20px',
  },
})
